import * as React from 'react'
import { SVGProps, memo } from 'react'

const RewardsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={21}
    height={24}
    viewBox='0 0 21 24'
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M11.349.688c-1.797.477-3.196 1.38-3.686 2.381-.275.56-.3.898-.3 4.073v3.462h-.872c-2.299 0-4.465 1.446-5.52 3.686C.525 15.237.5 15.38.5 17.055c0 1.678.024 1.817.476 2.779.616 1.31 1.698 2.444 2.939 3.08.85.435 1.171.512 2.369.567 1.168.053 1.53.008 2.302-.284 1.484-.56 2.82-1.695 3.421-2.905l.233-.467 1.067.091c2.245.193 5.059-.65 6.226-1.865.978-1.018.967-.926.967-7.831 0-5.286-.035-6.318-.23-6.802-.433-1.08-1.425-1.882-3.103-2.509C16.032.486 12.604.355 11.35.69Zm5.526 2.383c.93.379 1.559.908 1.559 1.312 0 .385-.697.96-1.604 1.322-1.054.421-3.642.577-4.871.293-.873-.202-1.835-.643-2.27-1.042-.633-.578-.043-1.411 1.364-1.928 1.037-.38 1.142-.393 3.1-.352 1.523.031 1.998.1 2.722.395ZM11.127 7.95c1.058.334 1.381.366 3.1.307 1.797-.063 2.654-.236 3.948-.8.236-.102.259.021.259 1.43v1.54l-.528.453c-1.597 1.37-5.841 1.47-7.792.182l-.684-.451V8.978c0-1.497.021-1.623.258-1.517.142.064.79.284 1.44.489ZM8.25 13.073c.81.38 1.687 1.237 2.114 2.062.254.491.318.876.318 1.92 0 1.54-.264 2.192-1.284 3.17-.92.882-1.757 1.18-3.121 1.108-1.004-.053-1.184-.115-1.96-.67-1.22-.876-1.73-1.793-1.8-3.241-.098-2.008.62-3.366 2.22-4.198 1.128-.586 2.464-.644 3.513-.15Zm10.185 1.652c0 1.368-.031 1.539-.334 1.835-.77.752-2.902 1.339-4.484 1.234l-.717-.047-.096-1.076c-.052-.591-.2-1.386-.33-1.766-.129-.38-.235-.726-.236-.768-.001-.043.845-.08 1.88-.085 1.638-.007 2.015-.06 2.914-.401.569-.216 1.117-.402 1.218-.414.137-.016.185.37.185 1.488Z'
      clipRule='evenodd'
    />
  </svg>
)

const Memo = memo(RewardsIcon)
export default Memo
